<mat-card class="contact-card">

    <div class="container">
        <div style="text-align:center">
            <h1>
                Contacts
            </h1>
        </div>

        <div>
            <div>
                <h2>Our Office:</h2>
                Bulgaria, Sofia, jk. Liulin 7, bl.735, of.5
                GSM: +359 xxx xxx xxx
            </div>

            <div class="text-white">
                <h2>Your location:</h2>
                <span>Latitude: {{currentLat}}</span>
                <span>Longitude: {{currentLong}}</span>
            </div>
            <div>
                <div #gmap id="gmap"></div>
            </div>
        </div>
    </div>

</mat-card>